import React, { Fragment } from 'react'
import cx from 'classnames'

import { Image } from 'components/_new/ui'
import { Href } from 'components/_new/controls'
import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import s from './Note.scss'


type NoteProps = {
  className?: string
  name: string
  image: string
  imageWidth?: number
  to?: string
  isActive?: boolean
}

const Note: React.FunctionComponent<NoteProps> = (props) => {
  const { className, name, image, imageWidth = 50, to, isActive } = props

  const rootClassName = cx(s.container, className, {
    [s.link]: Boolean(to),
    [s.active]: isActive,
  })

  const children = (
    <Fragment>
      <Box
        className={s.imageContainer}
        center
        mb={8}
      >
        <Image className={s.image} src={image} w={imageWidth} resizeBy="width" x2 x3 fullWidth />
        <div className={s.overlay} />
      </Box>
      <Text
        className={s.name}
        message={name}
        inherit
        align="center"
        color={isActive ? 'brand' : 'gray'}
      />
    </Fragment>
  )

  if (to) {
    return (
      <Href to={to} className={rootClassName} role="listitem">
        {children}
      </Href>
    )
  }

  return (
    <div className={rootClassName} role="listitem">
      {children}
    </div>
  )
}


export default Note
